import SendIcon from "@mui/icons-material/KeyboardArrowRight";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import classNames from "classnames";
import React, { useEffect, useState } from "react";

import MaterialModal from "../../../components/MaterialModal";
import { language } from "../../../language";

const GridContainer = styled(Grid)(({ theme }) => ({
  padding: "0 3%",
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: "2% 0 ",
}));

const HighlightedListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: "#F5F5F5",
}));

// Modal para a escolha do metadado ou criar novo componente

function ComponentModal({
  open, // True quando um novo componente for adicionado
  handleToggle, // Função para fechar o componente
  metadatas, // Lista de metadados
  componente, // Tipo e base do componente arrastado
  handleCreateComponent, // Ação para abrir o modal de configuração do componente
  onDrop, // Colocar o componente no formulário sem abrir o modal de configuração
}) {
  const [componentList, setcomponentList] = useState([]);
  const [componentSelected, setcomponentSelected] = useState(false);

  useEffect(() => {
    if (!metadatas || !componente) return;

    const type =
      typeof componente.payload.type === "object"
        ? componente.payload.type.name
        : componente.payload.element.type;

    const getMetadatasByType = metadatas?.content?.filter((item) => {
      return item.type.name === type;
    });

    setcomponentList(getMetadatasByType);
  }, [setcomponentList, metadatas, componente]);

  const putMetadataInForm = () => {
    const selectedComponentWithParseProperties = componentSelected;

    if (typeof selectedComponentWithParseProperties.properties !== "object") {
      selectedComponentWithParseProperties.properties = JSON.parse(
        componentSelected.properties,
      );
    }

    onDrop({
      ...componente,
      payload: selectedComponentWithParseProperties,
      openModal: true,
    });
    handleToggle();
  };

  const modalOverrideActions = () => {
    return (
      <GridContainer container justify="space-between">
        <Button
          color="primary"
          variant="contained"
          onClick={() => handleCreateComponent(componente)}
        >
          {language.CreateNewComponent}
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={!componentSelected}
          onClick={putMetadataInForm}
        >
          {language.Select}
        </Button>
      </GridContainer>
    );
  };

  // Define o metadado
  const handleSelectComponent = (comp) => {
    setcomponentSelected(comp);
  };

  const parserJson = (comp) => {
    try {
      return JSON.parse(comp.properties);
    } catch (error) {
      console.error("Erro ao fazer parse do JSON:", error);
      return [];
    }
  };

  return (
    <MaterialModal
      open={open}
      handleClose={handleToggle}
      title={language.ChooseComponentBase}
      size="md"
      overwriteActions={modalOverrideActions}
    >
      {componentList?.map((comp) => {
        const parsedMetaData = parserJson(comp);
        const metaDataFound = parsedMetaData.find((md) => md.id === "label");
        if (metaDataFound) {
          comp.name = metaDataFound.value;
        }
        return (
          <ListItem
            key={comp.id}
            button
            onClick={() => handleSelectComponent(comp)}
            className={classNames(componentSelected === comp && "highlighted")}
            sx={
              componentSelected === comp ? { backgroundColor: "#F5F5F5" } : {}
            }
          >
            <ListItemIcon>
              <SendIcon />
            </ListItemIcon>
            <ListItemText primary={comp.name} />
          </ListItem>
        );
      })}

      <StyledDivider variant="fullWidth" />
    </MaterialModal>
  );
}

export default ComponentModal;
